import service from '../service.js'

export default{
    listOvertime(){
        return service.get('overtime')
    },
    noteOvertime(ot_key,employee_key){
        return service.post('overtime',
        {
            ot_key       : ot_key,
            employee_key : employee_key,
        })
    },
}